/* Obj for endpoints back-end */
export const _ROUTES = {
  HOME: "/",
  LOGIN: "/login_check",
  LOGOUT: "/logout",
  RESET_PASS: "/reset-password",
  USERS: "/users",
  SET_PASSWORD: "/change-password",
  COMPANIES: "/companies",
  ACTIVITIES: "/activities",
  SITES: "/sites",
  SOURCES: "/sources",
  VOLUME_FILAIRE: "/volume-filaires",
  ACCOUNTS: "/account-parameters",
  ACCOUNTS_COPY: "/account-parameters/copy",
  IMPORT_ERRORS: "/import-errors",
  FORCE_IMPORT: "/force-manual-import",
  BUDGET_PARAMETERS: "/budget-parameters",
  INPUT_RATE_INCREASE: "/input-rate-increases",
  IPT_PAYROLLS: "/input-payrolls",
  IPT_HRS: "/input-hrs",
  IPT_HRS_GROUP: "/input-hrs/grouped-data",
  IPT_PLUMS_SPLIT_SOURCE: "/input-plums-split-sources",
  IPT_WASTE_RATE: "/input-waste-rates",
  IPT_WASTE_RATE_GROUP: "/input-waste-rates/grouped-data",
  IPT_SF: "/input-sale-filaires",
  CUSTOM_IPT_SF: "/volumes-filaire-data-label",
  SAVE_IPT_SF: "/save-volumes-filaire",
  IPT_ITS: "/input-its",
  IPT_ITS_GROUP: "/input-its/grouped-data",
  IPT_FLEET_OPTIMISATION: "/input-fleet-optimisations",
  IPT_FLEET_OPTIMISATION_GROUP: "/input-fleet-optimisations/grouped-data",
  GET_IPT_DEPRECIATION: "/depreciations-data-label",
  SAVE_DEPRECIATION: "/save-depreciations",
  IPT_SALE_AGG_MONTHS: "/input-sale-aggregate-months",
  IPT_SALE_AGG_PRICES: "/input-sale-aggregate-prices",
  IPT_SALE_DEPOT_PRODUCION_SPLIT: "input-sale-depot-production-splits",
  IPT_HIRE_EQUIPMENT: "/input-hire-equipments",
  IPT_HIRE_EQUIPMENT_GROUP: "/input-hire-equipments/grouped-data",
  IPT_SALES_DEPOT_DATA: "/input-sales-depot-data",
  SAVE_IPT_SALES_DEPOT: "/save-input-sale-depot",
  REAL_DATA: "/real-data",
  INDICATORS: "/indicators",
  INDICATORS_TEMPLATES: "/templates",
  INDICATOR_TEMPLATE_VIEW: "/template-data",
  INDICATOR_TEMPLATE_FILTERS: "/template-filters",
  ACCOUNT_PARAMETERS: "/account-parameters",
  ACCOUNT_PARAMETER_TYPES: "/account-parameters/types",
  BUDGET_SAVE: "/link-input-parameters",
  SAVE_FINANCIAL_DATA: "/save-financial-data",
  IPT_SALE_BLOCK_GROUP: "/input-sale-block-months/grouped-data",
  IPT_SALE_BLOCK_MONTH: "/input-sale-block-months",
  INPUT_SALE_BLOCKS: "/input-sale-blocks",
  DEPRECIATION: "/depreciations",
  IPT_SALE_QUARRYING_GROUP: "/input-sale-quarrying/grouped-data",
  SAVE_INPUT_SALE_QUARRYING: "/save-input-sale-quarrying",
  SAVE_DIESEL_IMPACT: "/save-diesel-impact",
  INPUT_SALE_QUARRYING_MONTH: "/input-sale-quarrying-months",
  NEW_BUDGET: "/new-budget",
  BUDGET: "/budgets",
  SAVE_TOTAL_COST_QUARRYING: "/save-total-cost-quarrying-months",
  IPT_SALE_TURNOVER_LRL: "/input-sale-turnover-lrl/grouped-data",
  SAVE_INPUT_SALE_TURNOVER_LRL: "/save-input-turnover-lrl",
  IPT_QUARRYING_EXC: "/input-sale-quarrying-months",
  EXPORT_BUDGET: "/export-budget",
  ADD_COMMENT: "/add-comment",
  DASHBOARD_INDICATORS: "/dashboard-indicators",
  UPLOAD: "/upload",
  FORCE_DELETE_FILES: "/delete-import-files",
};

/* Obj for router-dom */
export const _ROUTER_DOM_URL = {
  HOME: "/",
  DASHBOARD_GENERAL: "/dashboard-general",
  USERS: "/admin/users",
  COMPANIES: "/admin/companies",
  RESET_PASSWORD: "/reset-password",
  ACTIVITES: "/admin/activities",
  SITES: "/admin/sites",
  SOURCES: "/admin/sources",
  VOLUME_FILAIRE: "/admin/volume-filaire",
  NOT_ALLOWED: "/not-allowed",
  ACCOUNT_PARAMETERS: "/params/account-parameter",
  REAL_IMPORT: "/real-import",
  REAL_DATA: _ROUTES.REAL_DATA,
  INDICATORS_TEMPLATES: "/indicators/templates",
  INDICATORS_TEMPLATE_VIEW: "/indicators/template-view",
  BUDGET_PARAMETERS: "/budget/parameters",
  BUDGET_INPUT_INCREASE: "/budget/input-increase",
  BUDGET_INPUT_RATE_INCREASE: "/budget/input-rate-increase",
  BUDGET_INPUT_PAYROLL: "/budget/input-payroll",
  BUDGET_INPUT_HR: "/budget/input-hr",
  BUDGET_INPUT_PLUMS_SPLIT_SOURCE: "/budget/input-plums-split-source",
  BUDGET_INPUT_WASTE_RATE: "/budget/input-waste-rate",
  BUDGET_INPUT_SF: "/budget/input-sale-filaire",
  BUDGET_INPUT_ITS: "/budget/input-it",
  BUDGET_INPUT_FLEET_OPTIMISATION: "/budget/input-fleet-optimisation",
  INPUT_DEPRECIATION: "/budget/input-depreciation",
  INPUT_SALES_AGG: "/budget/input-sales-agg",
  BUDGET_INPUT_HIRE_EQUIPMENT: "/budget/input-hire-equipment",
  INPUT_SALES_DEPOT: "/budget/input-sales-depot",
  INPUT_SALES_BLOCK: "/budget/input-sales-block",
  INPUT_QUARRIYING_EXCAVATOR: "/budget/input-quarrying-excavator",
  INPUT_TURNOVER_LRL: "/budget/input-turnover-lrl",
  EXPORT_BUDGET: "/budget/export",
};
